import { render } from "./SurveyBuilder.vue?vue&type=template&id=d54b526a&scoped=true"
import script from "./SurveyBuilder.vue?vue&type=script&lang=js"
export * from "./SurveyBuilder.vue?vue&type=script&lang=js"

import "./SurveyBuilder.vue?vue&type=style&index=0&id=d54b526a&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d54b526a"]])

export default __exports__